<template>
    <Dialog v-model="show" title="Selecione um código de operação para visualizar o PDF" :show-close-button="true">
        <v-list>
            <v-list-item-group
                    color="primary"
            >
                <v-list-item
                        v-for="(item, i) in codigosOperacao"
                        :key="i"
                        @click="selecionarPdf(item)"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </Dialog>
</template>

<script>

  export default {
    name: 'DialogChoosePdf',
    props: {
      value: Boolean,
      codigosOperacao: { type: Array, default: () => [] },
      uuidPdf: { type: String }
    },
    computed: {
      show: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      }
    },
    methods: {
      selecionarPdf (codigo) {
        this.$emit('abrirPdf', codigo, this.uuidPdf)
        this.show = false
      }
    }
  }
</script>

<style scoped>

</style>
